<template>
  <div class="multiselect">
    <vt-combo-select
      ref="modelSelect"
      v-model="value"
      :ajax-search="params.ajaxSearch"
      :option-loader="params.optionLoader"
      :track-by="params.trackBy"
      :label="params.label"
      :custom-label="params.customLabel"
      :icon="params.icon"
      :max-height="maxHeight"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'VtSelectAsynchronousCellEditor',
    data() {
        return {
            value: null
        }
    },
    computed: {
        maxHeight() {
            return this.params.maxHeight ?? 120
        }
    },
    mounted() {
        this.value = this.params.value
        this.$nextTick(() => this.$refs.modelSelect?.activateDropdown())
    },
    methods: {
        /* Component Editor Lifecycle methods */
        // the final value to send to the grid, on completion of editing
        getValue() {
            return this.value
        }
    }
})
</script>
